import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import { db } from '../services/db.js'
import { docsService } from '@/services/docs.js'
import moment from 'moment'
// import VueCookie from 'vue-cookie'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    serverAddress: '',
    rootEndpoint: '/hs/MechanicsWorkstation/',
    products: {},
    goodsIsLoaded: false,
    docsLoaded: false,
    showRecommendationsList: false,
    userData: '',
    listDate: null,
    listPeriod: null,
    showFactColumns: false,
    testMode: false,
    useIdleVue: true,
    APIAddress: '',
    snackMessage: {},
    docList: {},
    docListArchived: {},
    lang: { lang: 'ua', flag: 'ua' },
    languages: [
      { lang: 'ua', flag: 'ua' },
      { lang: 'en', flag: 'gb' },
      { lang: 'ru', flag: 'ru' },
    ],
    backendVersion: '',
    arcDocs: false,
    forms: {}
  },
  actions: {
    initApp({ commit }) {
      db.initApp().then(response => {
        if (response && response.data) {
          db.fetchProducts()
          commit('setFeatures', response.data)
          router.push({ path: '/doclist/' })
        }
      })
    },
    getFormParam: (ctx,payload) => {
      const form = ctx.state.forms[payload.form]
      if (!form) {
        return undefined
      }
      return form[payload.key]
    },
    updateLang(context, payload) {
      context.commit('updateLang', payload)
    },
    getDocList({ commit }, payload) {
      if (
        !payload.dateFrom ||
        !payload.dateTo ||
        (this.state.docsLoaded === false &&
          this.state.listPeriod &&
          this.state.listPeriod.b === payload.dateFrom &&
          this.state.listPeriod.e === payload.dateTo)
      ) {
        return
      }

      commit('updateDocListStart', payload)
      docsService
        .getDocList(payload.dateFrom, payload.dateTo, !!payload.archivedDocs)
        .then(response => {
          commit(
            'updateDocList',
            Object.assign(
              {
                period:
                  this.state.listPeriod.b.startOf('day').toString() +
                  '-' +
                  this.state.listPeriod.e.endOf('day').toString(),
                data: response,
              },
              payload
            )
          )
        })
        .catch(error => {
          console.error(error)
          commit(
            'updateDocList',
            Object.assign(
              {
                period:
                  this.state.listPeriod.b.startOf('day').toString() +
                  '-' +
                  this.state.listPeriod.e.endOf('day').toString(),
                data: undefined,
              },
              payload
            )
          )
        })
    },
    showSnackMessage(context, payload) {
      context.commit('updateSnackMessage', payload)
    },
    updateUserData(context, payload) {
      context.commit('updateUserData', payload)
      localStorage.UserDataStatus = encodeURIComponent(payload.status)
      localStorage.UserDataStatusDescription = encodeURIComponent(
        payload.statusDescription
      )
      localStorage.workAreaAddress = encodeURIComponent(payload.workAreaAddress)
      localStorage.UserDataToken = encodeURIComponent(payload.token)
      localStorage.UserDataUserId = encodeURIComponent(payload.userId)
      localStorage.UserDataUserName = encodeURIComponent(payload.userName)
      localStorage.UserDataDoNotLimitWorkAreaAddress = encodeURIComponent(
        payload.doNotLimitWorkAreaAddress
      )
      let date = new Date(Date.now())
      date = date.getTime()
      localStorage.UserDataDate = date
      // if (payload) {
      //   context.dispatch('initApp')
      //   db.fetchProducts()
      //   router.push({ path: '/doclist/' })
      // }
    },
    updateShowFactColumns(state, payload) {
      localStorage.showFactColumns = payload
      this.commit('updateShowFactColumns', payload)
    },
    newUseIdleVue(state, payload) {
      localStorage.useIdleVue = payload
      this.commit('updateUseIdleVue', payload)
      state.useIdleVue = payload
    },
  },
  mutations: {
    setFormParam(state,payload) {
      let form = state.forms[payload.form]
      if (!form) {
        form = {}
        state.forms[payload.form] = {}
      }
      form[payload.key] = payload.data
      state.forms[payload.form] = {...state.forms[payload.form],...form}
    },
    resetStore(state) {
      state.docList = {}
      state.docListArchived = {}
      state.serverAddress = ''
      state.APIAddress = ''
      state.products = {}
      state.userData = {}
    },
    setFeatures: (state, payload) => {
      try {
        if (payload.features) {
          state.backendVersion = payload.features.version
          state.arcDocs = !!payload.features.arcDocs
        } else {
          state.backendVersion = 0
          state.arcDocs = true
        }
      } catch (e) {
        state.arcDocs = true;
        console.error(e)
      }
    },
    updateLang: (state, payload) => {
      state.lang = payload
      localStorage.currentLang = payload.lang
      localStorage.currentFlag = payload.flag
    },
    updateDocListStart(state, payload) {
      let newData = {}
      let period =
        payload.dateFrom.startOf('day').toString() +
        '-' +
        payload.dateTo.endOf('day').toString()
      newData[period] = []
      let curDocList
      if (payload.archivedDocs) {
        curDocList = state.docListArchived
        state.docListArchived = {}
        state.docListArchived = Object.assign(curDocList, newData)
      } else {
        curDocList = state.docList
        state.docList = {}
        state.docList = Object.assign(curDocList, newData)
      }
      state.docsLoaded = false
      state.listPeriod = { b: payload.dateFrom, e: payload.dateTo }
    },
    updateDocList(state, payload) {
      let newData = {}
      let curDocList
      let payloadData = payload.data
      if (payloadData) {
        payloadData.map(e => {
          //02.03.18 00:00
          e.docDateTime = moment(e.docDate, 'DD.MM.YY HH:mm')
          if (e.automobileName.match(/^\s*\|/)) {
            e.automobileName = e.automobileName.replace(/^\s*\|\s*/, '')
          }
        })
      }
      newData[payload.period] = payloadData

      if (payload.archivedDocs) {
        curDocList = state.docListArchived
        state.docListArchived = {}
        state.docListArchived = Object.assign(curDocList, newData)
      } else {
        curDocList = state.docList
        state.docList = {}
        state.docList = Object.assign(curDocList, newData)
      }

      state.docsLoaded = true
    },
    updateUserData(state, payload) {
      state.userData = payload
    },
    updateServerAddress(state, payload) {
      if (!payload && localStorage.demoMode) {
        payload = 'https://mt.dieselservice.com.ua/demo2018'
      }
      state.serverAddress = payload
      localStorage.serverAddress = payload
    },
    updateProducts(state, payload) {
      state.products = payload
    },
    fetchProducts(state, payload) {
      state.products = payload
      state.goodsIsLoaded = true
      localStorage.products = JSON.stringify(payload)
    },
    changeStatusProductsLoading(state, stat) {
      state.goodsIsLoaded = stat
    },
    changeStatusShowRecommendationsList(state, stat) {
      state.showRecommendationsList = stat
    },
    updateShowFactColumns: (state, payload) => {
      state.showFactColumns = payload
    },
    updateUseIdleVue: (state, payload) => {
      state.useIdleVue = payload
    },
    updateSnackMessage: (state, payload) => {
      state.snackMessage = payload
    },
    updateAPIAddress(state, payload) {
      state.APIAddress = payload
    },
  },
  getters: {
    serverEndpoint: state => {
      return state.serverAddress + state.rootEndpoint
    },
  },
})

export default store
